import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class IntermediateTimingRecordModel extends Model 
{
	@attr('date') entryTime;
	@attr('boolean',{defaultValue: true}) participatesInAutoAssociation;
	@attr('boolean',{defaultValue: false}) isPosted;
	
	@belongsTo('timing-impulse', {inverse: null, async: true}) impulseId;

	@belongsTo('intermediate-timing-point', {inverse: null, async: true}) IntermediateTimingPointId;
	@belongsTo('event', {inverse: 'intermediateTimingRecords', async: true}) EventId;
	@belongsTo('entry', {inverse: 'intermediateTimingRecords', async: true}) EntryId;
}